module.exports = __webpack_public_path__ + "media/FaktSoftPro-SemiBold_6b5426.eot";